package com.parmartechnologies.storage.collection

import com.parmartechnologies.storage.database.AppDatabase
import kotlinx.serialization.KSerializer
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject

class DatabaseCollection : DatabaseCollectionInterface, DatabaseCollectionHelper() {

    override fun <T> insert(data: T, serializer: KSerializer<T>) {
        val written = AppDatabase.shared().createDoc(data, serializer)
        println(written)
    }

    override fun <T> insertAll(list: List<T>, serializer: KSerializer<T>) {
        list.forEach { data ->
            AppDatabase.shared().createDoc(data, serializer)
        }
    }

    override fun <T> update(data: List<T>, serializer: KSerializer<T>) {
        data.forEach {
            val map = encodeToMap(serializer, it)
//            val written = AppDatabase.shared().updateDoc(getCollectionName(serializer), data, serializer)
//            println(written)
        }
    }

    override fun <T> updateOne(data: T, serializer: KSerializer<T>) {

    }

    override fun <T> updateOne(data: T, query: Map<String, Any?>, serializer: KSerializer<T>) {
        AppDatabase.shared().createDoc( data, serializer)
    }

    override fun <T> delete(id: String, serializer: KSerializer<T>) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().delete(collectionName, serializer,id)
    }

    override fun <T> delete(query: Map<String, Any?>, serializer: KSerializer<T>) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().delete(collectionName, serializer,query)
    }


    override fun <T> findOne(id: String, serializer: KSerializer<T>, callBack: (T?) -> Unit) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findOne(collectionName,serializer, id) { rows ->
            if (rows.isEmpty()) {
                callBack(null)
            } else {
                try {
                    rows.forEach { row ->
                        val collectionData =
                            json.decodeFromString<MutableMap<String, JsonElement>>(row)[collectionName]
                        val jsonObject = addBackTheId(collectionData)
                        val finalObject =
                            json.decodeFromJsonElement(serializer, JsonObject(jsonObject))
                        callBack(finalObject)
                    }
                } catch (e: Exception) {
                    callBack(null)
                }
            }
        }
    }


    override fun <T> findOne(
        andQuery: Map<String, Any?>,
        serializer: KSerializer<T>,
        callBack: (T?) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findOne(collectionName, serializer,andQuery) { rows ->
            if (rows.isNotEmpty()) {
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(rows.toString())[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    val finalObject = json.decodeFromJsonElement(serializer, JsonObject(jsonObject))
                    callBack(finalObject)
                } catch (e: Exception) {
                    println(e.message)
                }
            } else {
                callBack(null)
            }
        }
    }

    override fun <T> findOne(
        andQuery: Map<String, Any?>,
        orQuery: Map<String, Any?>,
        serializer: KSerializer<T>,
        callBack: (T?) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findOne(collectionName,serializer ,andQuery, orQuery) { rows ->
            if (rows.isNotEmpty()) {
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(rows.toString())[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    val finalObject = json.decodeFromJsonElement(serializer, JsonObject(jsonObject))
                    callBack(finalObject)
                } catch (e: Exception) {
                    println(e.message)
                }
            } else {
                callBack(null)
            }
        }
    }

    override fun <T> findAll(
        andQuery: Map<String, Any?>,
        serializer: KSerializer<T>,
        callBack: (List<T>) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findAll(collectionName, serializer,andQuery) { rows ->
            val allData: MutableList<T> = mutableListOf()
            rows.forEach { row ->
                try {
                    val collectionData = json.decodeFromString<MutableMap<String, JsonElement>>(row)
                    val finalCollectionData = collectionData[collectionName]
                    val jsonObject = addBackTheId(finalCollectionData)
                    allData.add(json.decodeFromJsonElement(serializer, JsonObject(jsonObject)))
                } catch (e: Exception) {
                    println(e.message)
                }
            }
            callBack(allData)
        }
    }

    override fun <T> findAll(
        andQuery: Map<String, Any?>,
        orQuery: Map<String, Any?>,
        serializer: KSerializer<T>,
        callBack: (List<T>) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findAll(collectionName, serializer,andQuery, orQuery) { rows ->
            val allData: MutableList<T> = mutableListOf()
            rows.forEach { row ->
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(row)[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    allData.add(json.decodeFromJsonElement(serializer, JsonObject(jsonObject)))
                } catch (e: Exception) {
                    println(e.message)
                }
            }
            callBack(allData)
        }
    }

    override fun <T> findAllOr(
        orQuery: Map<String, Any?>,
        serializer: KSerializer<T>,
        callBack: (List<T?>) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findAllOr(collectionName, serializer,orQuery) { rows ->
            val allData: MutableList<T> = mutableListOf()
            rows.forEach { row ->
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(row)[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    allData.add(json.decodeFromJsonElement(serializer, JsonObject(jsonObject)))
                } catch (e: Exception) {
                    println(e.message)
                }
            }
            callBack(allData)
        }
    }

    override fun <T> findOneByUserId(
        id: String,
        serializer: KSerializer<T>,
        callBack: (T?) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findOneByUserId(collectionName, serializer,id) { row ->
            if (row.isNotEmpty()) {
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(row.toString())[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    val finalObject = json.decodeFromJsonElement(serializer, JsonObject(jsonObject))
                    callBack(finalObject)
                } catch (e: Exception) {
                    println(e.message)
                }
            } else {
                callBack(null)
            }
        }
    }

    override fun <T> findAllByUserId(
        id: String,
        serializer: KSerializer<T>,
        callBack: (List<T>) -> Unit
    ) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().findAllByUserId(collectionName, serializer,id) { rows ->
            val allData: MutableList<T> = mutableListOf()
            rows.forEach { row ->
                try {
                    val collectionData =
                        json.decodeFromString<MutableMap<String, JsonElement>>(row)[collectionName]
                    val jsonObject = addBackTheId(collectionData)
                    allData.add(json.decodeFromJsonElement(serializer, JsonObject(jsonObject)))
                } catch (e: Exception) {
                    println(e.message)
                }
            }
            callBack(allData)
        }
    }


    override fun <T> findOneByBusinessId(
        id: String,
        serializer: KSerializer<T>,
        callBack: (T?) -> Unit
    ) {
        AppDatabase.shared().findAllByBusinessId(id, serializer) { rows ->
            if (rows.count() > 0) {
                callBack(rows.first())
            } else {
                callBack(null)
            }
        }
    }

    override fun <T> findAllByBusinessId(
        id: String,
        serializer: KSerializer<T>,
        callBack: (List<T>) -> Unit
    ) {
        AppDatabase.shared().findAllByBusinessId(id, serializer) { rows ->
            callBack(rows)
        }
    }

    override fun <T> deleteAll(serializer: KSerializer<T>) {
        val collectionName = getCollectionName(serializer)
        AppDatabase.shared().deleteAll(collectionName,serializer)
    }

}